<template>
  <div class="DiscountBox">
    <h4 class="DiscountBox_title">
      {{ title }}
      <span v-if="titleTips" class="font-weight-normal">
        {{ titleTips }}
      </span>
    </h4>

    <form class="DiscountBox_form" v-if="appliedResult.type !== 'success'">
      <app-text-input
        class="input-discount"
        v-model.trim="promotionCode"
        :disabled="isApplying"
      />

      <app-button
        type="submit"
        class="button-discount"
        @click.prevent="$emit('apply-promotion-code', promotionCode)"
        :is-loading="isApplying"
        :disabled="!promotionCode"
      >
        {{ buttonText }}
      </app-button>
    </form>

    <template v-if="appliedResult.type">
      <p class="coupon-apply-info coupon-valid" v-if="appliedResult.type === 'success'">
        <app-icon name="success" />
        {{ appliedResult.message }}:<br>
        {{ appliedResult.promotion.code }}: {{ appliedResult.promotion.description }}
      </p>

      <p class="coupon-apply-info coupon-invalid" v-else>
        <app-icon name="error" />
        {{ appliedResult.message }}
      </p>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'discount-box',

    props: {
      title: {
        type: String,
        default () {
          return this.$t('common.discountBox.title', 'Vourcher discount code')
        }
      },

      titleTips: {
        type: String,
        default: null
      },

      buttonText: {
        type: String,
        default () {
          return this.$t('common.discountBox.button', 'Apply')
        }
      },

      isApplying: {
        type: Boolean,
        default: false
      },

      appliedResult: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    data () {
      return {
        promotionCode: null
      }
    }
  }
</script>
